export const CART_TYPES = {
    REGULAR: 'regular',
    RENTAL: 'rental',
    SLICE3: 'slice3',
    ESTO_SLICE3: 'esto_slice3',
} as const;

export const DOM_IDS = {
    PRODUCT_NAME: 'detail-product-name-label',
    PRODUCT_SKU: 'detail-product-sku-label',
} as const;

export const PRODUCT_TYPES = {
    SIMPLE_PRODUCT_TYPE: 'simple',
} as const;

export const CUSTOM_EVENTS = {
    GTM_PRODUCT_EVENT: 'gtm_product_event',
    CART_ALTERED: 'cart-altered',
    PRODUCT_CONFIGURATION_CHANGE: 'product-configuration-change',
} as const;

export const GTM_EVENT_NAMES = {
    VIEW_ITEM: 'view_item',
} as const;

export const CART_ACTIONS = {
    ADD_TO_CART: 'add-to-cart',
} as const;

export const ITEM_LIST_NAMES = {
    PRODUCT_DETAIL_VIEW: 'Product detail view',
} as const;

export const SESSION_STORAGE_KEYS = {
    CART_FLOW: 'cartFlow',
} as const;

export const URL_PARAMS = {
    SLICE3: 'slice3',
    ESTO_SLICE3: 'esto_slice3',
} as const;

export const HTML_CLASSES = {
    CART_CALLOUT_SUCCESS: 'cart-callout intent-success',
    CART_CALLOUT_DANGER: 'cart-callout intent-danger',
    PRODUCT_PRICING: 'product-pricing type02',
    LABEL_NOTICE: 'label notice',
    PRODUCT_SALE: 'product-sale',
    LAYOUT_PRODUCT_IMAGE: 'layout-product__image',
    LAYOUT_PRODUCT_CONTENT: 'layout-product__content',
    PRODUCT_IMAGE: 'product-image',
    PRODUCT_CONFIGURATOR: 'product-configurator',
    LONGTEXT: 'longtext',
    BUTTON: 'button',

    FRAME_IDEAL_PAGE_HEADER: 'frame-ideal__page-header',
    FRAME_IDEAL_BODY: 'frame-ideal__body',
    FRAME_IDEAL_BODY_LIMITER: 'frame-ideal__body__limiter',
    LAYOUT_PRODUCT: 'layout-product',
    LAYOUT_PRODUCT_CODE: 'layout-product__code',
    PRODUCT_NUGGETS: 'product-nuggets',
    PRODUCT_NUGGETS_ICON: 'product-nuggets__icon',
    PRODUCT_NUGGETS_TEXT: 'product-nuggets__text',
    PRODUCT_PRICING_OPTIONS: 'product-pricing__options',
    PRODUCT_PRICING_OPTION: 'product-pricing__option',
    PRODUCT_PRICING_BUTTON: 'product-pricing__button secondary',
    PRODUCT_CTA: 'product-cta',
    PRODUCT_BLOCK: 'product-block',
    PRODUCT_BLOCK_TITLE: 'product-block__title',
    BREADCRUMB: 'breadcrumb',
    PATH: 'path',
    PRE_TITLE: 'pre-title',
    PRICE: 'price',
    PRICE_AVG: 'price avg',
    PRICE_LABEL: 'price-label',
    STATUS: 'status',
    LABEL: 'label',
} as const;

export const COMPONENT_TIMEOUTS = {
    PRODUCT_CONFIGURATION_CHANGE: 50,
} as const;
